import { action } from 'easy-peasy';
import { IActionSetMoreHospitalEvents } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreHospitalEvents: IActionSetMoreHospitalEvents = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  const newItems = mergeUniqueBy(state.events, payload, item => item.id);

  state.events = [...newItems];
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreHospitalEvents;
